import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar/Navbar";
import Footer from "../Components/Footer/Footer";
import { animateScroll as scroll } from "react-scroll";
import { useParams } from "react-router-dom";
import { getData } from "../Config/FirebaseMethod";
import { Box, CircularProgress } from "@mui/material";
import { Helmet } from "react-helmet-async";

const ProjectPage = () => {
  const { projectName } = useParams();
  const [projectData, setProjectData] = useState({});
  const [isLoading, setisLoading] = useState(true);
  const [check, setCheck] = useState(true);

  let sendStdData = () => {
    // setisLoading(true);
    // getData(`Projects/`)
    //   .then((res) => {
    //     setisLoading(false);
    //     if (Array.isArray(res) && res.length > 0) {
    //       setProjectData(res[0]);
    //     }
    //   })
    setisLoading(true);
    getData(`Projects/`)
      .then((res) => {
        if (Array.isArray(res) && res.length > 0) {
          // Find the project that matches projectName with projectLink
          const matchingProject = res.find(
            (project) => project.projectLink === projectName
          );

          if (matchingProject) {
            setProjectData(matchingProject);
            setCheck(false);
          } else {
            // Handle case where no matching project is found
            console.log("No matching project found.");
            setCheck(true);
          }
        }
        setisLoading(false);
      })
      .catch((err) => {
        setisLoading(false);
        alert(err);
      });
  };

  useEffect(() => {
    sendStdData();

    // if (projectData.projectTitle) {
    //   document.title = `${projectData.projectTitle} | Aneeq Ullah Khan`;
    // }
    scroll.scrollToTop({ duration: 500 });
  }, [projectData.projectTitle]);

  return (
    <div>
      {projectData && (
        <Helmet>
          <title>{`${projectData.projectTitle} | Aneeq Ullah Khan`}</title>
          <meta name="description" content={projectData.projectDesc} />
          <meta
            name="keywords"
            content="Aneeq Ullah Khan, Aneeq Ullah Khan Services, Services Aneeq Ullah Khan, Aneeq Khan Services"
          />
        </Helmet>
      )}
      <Navbar />
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "80vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : check ? (
        <div className="container mt-5 mb-5">
          <h3 className="text-center">Coming Soon</h3>
        </div>
      ) : (
        <div className="container mt-3">
          <div
            id="carouselExampleAutoplaying"
            class="carousel slide"
            data-bs-ride="carousel"
            style={{ border: "5px solid #46acf4", borderRadius: "15px" }}
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src={projectData.projectImg1}
                  class="d-block w-100"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src={projectData.projectImg2}
                  class="d-block w-100"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src={projectData.projectImg3}
                  class="d-block w-100"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src={projectData.projectImg4}
                  class="d-block w-100"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleAutoplaying"
              data-bs-slide="prev"
            >
              <span
                class="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleAutoplaying"
              data-bs-slide="next"
            >
              <span
                class="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
          <div className="mt-5 mb-3">
            <h3>{projectData.projectTitle}</h3>
            <p>{projectData.projectDesc}</p>
            <h4 className="mt-3 mb-3">Key Features</h4>
            <li>{projectData.projectKey1}</li>
            <li>{projectData.projectKey2}</li>
            <li>{projectData.projectKey3}</li>
            <li>{projectData.projectKey4}</li>
            <li>{projectData.projectKey5}</li>
            <li>{projectData.projectKey6}</li>
            <li>{projectData.projectKey7}</li>
            <h4 className="mt-3">Project Link</h4>
            <a href={projectData.projectWebLink} target="_blank">
              Click Here
            </a>
            <br />
            <div className="mb-5"></div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default ProjectPage;
